import {
  withFormsy,
} from 'formsy-react';

import InputHiddenView from './InputHiddenView';

const InputComponent = withFormsy(InputHiddenView);

const Component = InputComponent;

export default Component;
